import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { refreshOasisDefinitionOptions } from '@generated';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { Button } from '~/shared/components/buttons/Button';
import { useMutation } from '~/util/http/useMutation';
import { TableActions } from '~/shared/data-tables/TableActions';

const OasisDefinitionsDataTable = createQueryDataTable('oasis-definitions');
type RowType = RowOfQueryDataTable<typeof OasisDefinitionsDataTable>;
type TableProps = PropsOfQueryDataTable<typeof OasisDefinitionsDataTable>;

function ActionsCell({ row }: { row: RowType }) {
	const navigate = useNavigate();
	const refreshTask = useMutation(refreshOasisDefinitionOptions);

	const onRefresh = () => {
		refreshTask.mutate({
			systemName: row.systemName
		});
	};

	return (
		<TableActions>
			<Button Icon={RefreshCw} aria-label="Refresh Task Definition" isDisabled={refreshTask.isPending} onClick={onRefresh} />
			<TableActions.ViewButton aria-label="Edit Task Definition" onClick={() => navigate(`edit/${row.id}`)} />
		</TableActions>
	);
}

const columnDefinitions = OasisDefinitionsDataTable.columns([
	{
		header: 'Title',
		key: 'title',
		sortable: true
	},
	{
		header: 'System Name',
		key: 'systemName',
		sortable: true
	},
	{
		header: 'Actions',
		key: 'actions',
		width: 'w-[100px]',
		renderCell: row => <ActionsCell row={row} />
	}
]);

export function OasisDefinitionTable(props: TableProps) {
	return <OasisDefinitionsDataTable.Table columns={columnDefinitions} emptyMessage="No intervention definitions found." {...props} />;
}
